export default __webpack_public_path__ + "static/media/walletconnect.6af5dd08.svg";